import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SpinnerService {
  readonly isLoading = signal(false);
  private pending = 0;
  /** Reference count of active "suppressed" holders. Zero -> spinner allowed. */
  private suppressDepth = 0;

  show(): void {
    if (this.suppressDepth > 0) return;
    this.pending++;
    this.isLoading.set(true);
  }

  hide(): void {
    if (this.suppressDepth > 0) return;
    if (this.pending > 0) {
      this.pending--;
    }
    if (this.pending === 0) {
      this.isLoading.set(false);
    }
  }

  /**
   * Suppression is reference-counted so that one flow releasing suppression
   * never cancels another flow's suppression. Passing `true` acquires a hold
   * (and clears the spinner); `false` releases a single hold if present.
   */
  setSuppressed(suppressed: boolean): void {
    if (suppressed) {
      this.suppressDepth++;
      this.pending = 0;
      this.isLoading.set(false);
    } else {
      if (this.suppressDepth > 0) {
        this.suppressDepth--;
      }
    }
  }

  reset(): void {
    this.suppressDepth = 0;
    this.pending = 0;
    this.isLoading.set(false);
  }
}
